module.exports = __webpack_public_path__ + "img/icon-back-to.56ccbd9b.svg";